import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const FacultyDashboard = lazyPage(() => import('@/pages/faculty/Dashboard'));
const MyTimetable = lazyPage(() => import('@/pages/faculty/MyTimetable'));
const MyClassWorkspace = lazyPage(() => import('@/pages/faculty/MyClassWorkspace'));
const FacultyAttendance = lazyPage(() => import('@/pages/faculty/Attendance'));
const LessonPlans = lazyPage(() => import('@/pages/faculty/LessonPlans'));
const FacultyAssignments = lazyPage(() => import('@/pages/faculty/Assignments'));
const FacultyHomework = lazyPage(() => import('@/pages/faculty/Homework'));
const MarksEntry = lazyPage(() => import('@/pages/faculty/MarksEntry'));
const ClassTeacherRemarks = lazyPage(() => import('@/pages/faculty/ClassTeacherRemarks'));
const StudentPerformance = lazyPage(() => import('@/pages/faculty/StudentPerformance'));
const FacultyParentCommunication = lazyPage(() => import('@/pages/faculty/ParentCommunication'));
const LeaveManagement = lazyPage(() => import('@/pages/faculty/LeaveManagement'));
const MyProfile = lazyPage(() => import('@/pages/faculty/MyProfile'));
export const facultyRoutes: AppRoute[] = [
  {
    path: 'faculty',
    title: 'Faculty Portal',
    children: [
      { path: '', title: 'Faculty Portal', redirectTo: '/faculty/dashboard' },
      {
        path: 'dashboard',
        title: 'Dashboard',
        component: FacultyDashboard,
      },
      {
        path: 'timetable',
        title: 'My Timetable',
        component: MyTimetable,
        yearScoped: true,
      },
      {
        path: 'classes',
        title: 'My Class',
        component: MyClassWorkspace,
        yearScoped: true,
      },
      { path: 'students', title: 'Student List', redirectTo: '/faculty/classes?tab=students' },
      {
        path: 'attendance',
        title: 'Attendance',
        component: FacultyAttendance,
        yearScoped: true,
      },
      {
        path: 'lesson-plans',
        title: 'Lesson Plans',
        component: LessonPlans,
        yearScoped: true,
      },
      {
        path: 'assignments',
        title: 'Assignments',
        component: FacultyAssignments,
        yearScoped: true,
      },
      {
        path: 'homework',
        title: 'Homework',
        component: FacultyHomework,
        yearScoped: true,
      },
      { path: 'marks', title: 'Marks Entry', component: MarksEntry },
      {
        path: 'remarks',
        title: 'Class Teacher Remarks',
        component: ClassTeacherRemarks,
        yearScoped: true,
      },
      {
        path: 'performance',
        title: 'Student Performance',
        component: StudentPerformance,
      },
      {
        path: 'parent-communication',
        title: 'Parent Communication',
        component: FacultyParentCommunication,
      },
      {
        path: 'leave',
        title: 'Leave Management',
        component: LeaveManagement,
      },
      { path: 'profile', title: 'My Profile', component: MyProfile },
      // The profile menu's link: under no Fabrica menu, so every signed-in teacher reaches their own profile.
      { path: 'my-profile', title: 'My Profile', component: MyProfile },
    ],
  },
];
